import { useLocation } from "wouter";

export function usePathname() {
  return useLocation()[0];
}
